import _toConsumableArray from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module list/todolist/checktodolistcommand
 */
import { Command } from 'ckeditor5/src/core.js';
import { getAllListItemBlocks } from '../list/utils/model.js';
/**
 * The check to-do command.
 *
 * The command is registered by the {@link module:list/todolist/todolistediting~TodoListEditing} as
 * the `checkTodoList` editor command.
 */
var CheckTodoListCommand = /*#__PURE__*/function (_Command) {
  _inherits(CheckTodoListCommand, _Command);
  var _super = _createSuper(CheckTodoListCommand);
  /**
   * @inheritDoc
   */
  function CheckTodoListCommand(editor) {
    var _this;
    _classCallCheck(this, CheckTodoListCommand);
    _this = _super.call(this, editor);
    // Refresh command before executing to be sure all values are up to date.
    // It is needed when selection has changed before command execution, in the same change block.
    _this.on('execute', function () {
      _this.refresh();
    }, {
      priority: 'highest'
    });
    return _this;
  }
  /**
   * Updates the command's {@link #value} and {@link #isEnabled} properties based on the current selection.
   */
  _createClass(CheckTodoListCommand, [{
    key: "refresh",
    value: function refresh() {
      var selectedElements = this._getSelectedItems();
      this.value = this._getValue(selectedElements);
      this.isEnabled = !!selectedElements.length;
    }
    /**
     * Executes the command.
     *
     * @param options.forceValue If set, it will force the command behavior. If `true`, the command will apply
     * the attribute. Otherwise, the command will remove the attribute. If not set, the command will look for its current
     * value to decide what it should do.
     */
  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.editor.model.change(function (writer) {
        var selectedElements = _this2._getSelectedItems();
        var value = options.forceValue === undefined ? !_this2._getValue(selectedElements) : options.forceValue;
        var _iterator = _createForOfIteratorHelper(selectedElements),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var element = _step.value;
            if (value) {
              writer.setAttribute('todoListChecked', true, element);
            } else {
              writer.removeAttribute('todoListChecked', element);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
    /**
     * Returns a value for the command.
     */
  }, {
    key: "_getValue",
    value: function _getValue(selectedElements) {
      return selectedElements.every(function (element) {
        return element.getAttribute('todoListChecked');
      });
    }
    /**
     * Gets all to-do list items selected by the {@link module:engine/model/selection~Selection}.
     */
  }, {
    key: "_getSelectedItems",
    value: function _getSelectedItems() {
      var model = this.editor.model;
      var schema = model.schema;
      var selectionRange = model.document.selection.getFirstRange();
      var startElement = selectionRange.start.parent;
      var elements = [];
      if (schema.checkAttribute(startElement, 'todoListChecked')) {
        elements.push.apply(elements, _toConsumableArray(getAllListItemBlocks(startElement)));
      }
      var _iterator2 = _createForOfIteratorHelper(selectionRange.getItems({
          shallow: true
        })),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          if (schema.checkAttribute(item, 'todoListChecked') && !elements.includes(item)) {
            elements.push.apply(elements, _toConsumableArray(getAllListItemBlocks(item)));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return elements;
    }
  }]);
  return CheckTodoListCommand;
}(Command);
export { CheckTodoListCommand as default };